import {Component, inject, OnInit} from '@angular/core';
import {Router} from '@angular/router'; // Añadido
import {MatIconModule} from '@angular/material/icon'; // Añadido
import {MatButtonModule} from '@angular/material/button';
import {SkeletonCategories} from '../../components/skeleton-categories/skeleton-categories';
import {CategoryCard} from '../../components/category-card/category-card';
import {CatalogStore} from '@store/catalog.store';

@Component({
  selector: 'app-categories',
  standalone: true,
  imports: [
    SkeletonCategories,
    CategoryCard,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './categories.html',
  styleUrl: './categories.scss'
})
export class Categories implements OnInit {
  private readonly store = inject(CatalogStore);
  protected readonly category = this.store.categories;
  private readonly router = inject(Router); // Añadido

  ngOnInit(): void {

  }


  goToFavorites() {
    this.router.navigate(['/standard/favorites']);
  }
}
